// biome-ignore lint/style/useImportType: keeping value import for compatibility
import * as React from 'react';
import { type FC, memo } from 'react';

import cn from 'classnames';

interface NavItemProps {
  isActive?: boolean;
  label: string;
}

const NavItem: React.FC<React.PropsWithChildren<NavItemProps>> = ({
  isActive,
  label,
}) => (
  <li
    className={`${cn({
      'border-l-4 pl-16': isActive,
      'pl-20': !isActive,
    })} border-solid border-primary-main py-4  mb-24`}
  >
    <p
      className={`font-link text-left ${
        isActive ? 'text-primary-main' : 'text-gray-dark'
      } md:hover:text-primary-light`}
      style={{ textTransform: 'capitalize' }}
    >
      {label}
    </p>
  </li>
);

interface AsideNavProps {
  recourceTypes: string[];
  onSelect: (id: string) => void;
  selectedTypeResource: string;
  className?: string;
}

const AsideNav: FC<React.PropsWithChildren<AsideNavProps>> = ({
  recourceTypes,
  onSelect,
  selectedTypeResource,
  className,
}) => (
  <aside className={`flex flex-col items-start mt-20 pt-8 ${className}`}>
    {recourceTypes.map(recourceType => (
      <button
        type="button"
        key={recourceType}
        onClick={() => {
          onSelect(recourceType);
        }}
      >
        <NavItem
          isActive={recourceType === selectedTypeResource}
          label={recourceType}
        />
      </button>
    ))}
  </aside>
);

export default memo(AsideNav);
